import { Controller } from "stimulus"
import Sortable from "sortablejs"
import client from '../../helpers/client'

export default class extends Controller {
  static values = { group: String }

  connect() {
    this.isUpdating = false
    this.sortable = Sortable.create(this.element, {
      group: this.groupValue || "shared",
      animation: 150,
      onStart: this.start.bind(this),
      onEnd: this.end.bind(this),
      onMove: this.move.bind(this),
      filter: ".no-drag",
      disabled: false
    })
  }

  move(event) {
    // Prevent dropping before or after no-drag items
    const { related } = event
    if (related && related.classList.contains('no-drag')) {
      return false
    }
    return true
  }

  start(event) {
    // If we're already updating, disable further dragging
    if (this.isUpdating) {
      event.preventDefault()
      return false
    }
    
    const wrapperClassTarget = this.wrapperClassTarget(event)
    if(wrapperClassTarget) {
      wrapperClassTarget.classList.add("dragging")
    }
  }

  async end(event) {
    // If we're already updating, cancel this drag
    if (this.isUpdating) {
      return
    }

    this.isUpdating = true
    this.sortable.option("disabled", true)

    const { item, to } = event
    const { id } = item.dataset
    const dropParamAttribute = to.getAttribute("data-drop-params")
    const additionalParams = dropParamAttribute ? JSON.parse(dropParamAttribute) : {}

    const wrapperClassTarget = this.wrapperClassTarget(event)
    if(wrapperClassTarget) {
      wrapperClassTarget.classList.remove("dragging")
    }

    try {
      const url = this.element.getAttribute('data-drag-url').replace(":id", id)
      // Adjust position to account for non-draggable items at the top
      const nonDraggableCount = to.querySelectorAll('.no-drag').length
      const adjustedPosition = event.newIndex + 1 - nonDraggableCount
      const response = await client.put(url, {
        ...additionalParams,
        position: adjustedPosition
      })
      console.log(response)
    } catch (e) {
      alert("Unable to update sort order. Please refresh the page and try again.")
      console.log(e)
    } finally {
      this.isUpdating = false
      this.sortable.option("disabled", false)
    }
  }

  wrapperClassTarget(event) {
    if(!event) {
      return null
    }

    const wrapperTargetSelector = event.to.getAttribute("data-drag-wrapper-class-target")
    if(!wrapperTargetSelector) {
      return null
    }

    return document.querySelector(wrapperTargetSelector)
  }
}
